export default {"src":"/_next/static/media/message.dda34175.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};